export default "__VITE_ASSET__z88kbwkb__$_?url__"